import ReportingTeamModal from "./ReportingTeamModal";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { hideLoader, showLoader } from "../../utils/loaderSlice";
import PlusIcon from "../../assets/images/icons/PlusIcon";
import ReactTableComponent from "../UniversalComponents/ReactTableComponent";
import {
  useFetchTeamAllDataQuery,
  usePostAddTeamMemberMutation,
  usePostCustomerAddTeamMutation,
} from "../../utils/customer/customerSelect";
import { getInitials } from "../../utils/utilityFunctions/stringUtility";
import { ReactComponent as NoTeamIcon } from "../../assets/images/NoTeamIcons.svg";
import AvatarName from "../UniversalComponents/AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";
import { getUserToken } from "../../utils/utilityFunctions/localServices";
import useRequireAuth from "../../utils/useRequireAuth";
import { pushAlert } from "../../utils/alertSlice";

const CustomerReportingTeam = () => {
  const { id: customerId } = useParams();
  const dispatch = useDispatch();
  const [teamMember, setTeamMember] = useState([]);
  const [teamData, setTeamData] = useState({});
  const { token } = useRequireAuth();

  const {
    data: allOptionData,
    isFetching: isTeamListFetching,
    refetch: refetchAllOption,
    isLoading,
    isError,
  } = useFetchTeamAllDataQuery({ key: "all", customer_id: customerId });

  useEffect(() => {
    if (allOptionData) {
      refetchAllOption();
      const { team_members } = allOptionData?.data;
      setTeamMember(team_members);
    }
  }, [allOptionData]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setTeamData({});
  };

  useEffect(() => {
    if (isTeamListFetching) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [isTeamListFetching]);

  const [
    postAddTeamMember,
    {
      data: teamPostData,
      isError: teamPostError,
      isSuccess: teamPostSuccess,
      isLoading: teamPostLoading,
      headerLoading,
      headererror,
    },
  ] = usePostAddTeamMemberMutation();

  const HoverCard = ({ name, emailID, mobile, handleCLick }) => {
    return (
      <div className="py-2 min-w-[17.78rem]">
        <div className="rounded-lg bg-white">
          <div className="border-b-2 space-y-2 pb-2">
            <div className="flex px-2 space-x-2">
              <div>
                <AvatarName
                  name={getInitials(name)}
                  size="small"
                  bgColor={"#E8ECF299"}
                  textColor={"#7C7C83"}
                  borderColor={"#ABABAC"}
                />
              </div>
              <div className="text-2999BC text-14">{name ?? "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <EmailIcon />
              </div>
              <div className="text-F16136 text-12">{emailID ?? "-"}</div>
            </div>

            <div className="flex px-2 space-x-2 my-2">
              <div className="w-5 text-center">
                <PhoneIcon />
              </div>
              <div className="text-F16136 text-12">{mobile ?? "-"}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleToggleCLick = async (rowData, headerKey) => {
    const updatedData = {
      customerId: rowData.customer_id,
      id: rowData.id,
      roleId: rowData.role_id,
      skillLevelId: rowData.skill_level_id,
      teamId: rowData.team_id,
      userId: rowData.user_id,
      ...(headerKey === "status"
        ? { status: !rowData.status, isBillable: rowData.is_billable }
        : { isBillable: !rowData.is_billable, status: rowData.status }),
    };

    // if(headerKey === "status"){
    //   updatedData.status = !rowData.status;
    // }
    // if(headerKey === "is_billable"){
    //   updatedData.isBillable = !rowData.is_billable;
    // }
    console.log(rowData, headerKey, updatedData, "boomshakalakaaa");

    try {
      const response = await postAddTeamMember({ data: updatedData, isUpdate: true }).unwrap();

      console.log(response, "responseheheh");
      if (response?.success) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      console.error("erro updating ", error);
      dispatch(pushAlert({ visible: true, message: error.message || "An error occurred", type: "danger" }));
    }
  };

  useEffect(() => {
    if (teamPostSuccess) {
      refetchAllOption();
    }
  }, [teamPostSuccess]);

  return (
    <div className="tablemaindiv h-full ">
      <div className=" overflow-y-auto h-full flex flex-col thinscroll">
        <ReactTableComponent
          tablename="Reporting Team"
          headers={[
            {
              accessor_key: "user_name",
              label: "Name",
              callingFunction: () => {},
              // StopPropagation: ()=>{},
              tooltip: (data) => (
                <HoverCard
                  name={data?.data?.user_name ?? "N/A"}
                  emailID={data?.data?.email ?? "N/A"}
                  mobile={data?.data?.mobile ?? "N/A"}
                />
              ),
            },
            {
              accessor_key: "team_name",
              label: "team",
              // callingFunction: () => console.log("Called Column Function"),
            },
            {
              accessor_key: "skill_level",
              label: "skill level",
              // callingFunction: () => console.log("Called Column Function"),
            },
            {
              accessor_key: "role_name",
              label: "role",
              //callingFunction: () => console.log("Called Column Function"),
              // tooltip: (data) => (
              //   <HoverCard
              //     name={data?.data?.reporting}
              //     emailID={data?.data?.manager_email}
              //     mobile={data?.data?.manager_phone}
              //   />
              // ),
              // tooltip: (data) => console.log(data, "companydata"),
            },
            {
              accessor_key: "status",
              label: "status",
              boolColumn: true,
              boolState: {
                trueState: "Active",
                falseState: "Inactive",
              },

              state: () => console.log(""),
            },
            {
              accessor_key: "is_billable",
              label: "billable",
              boolColumn: true,
              boolState: {
                trueState: "Yes",
                falseState: "No",
              },
              // callingFunction: () => console.log("Called Column Function"),
            },
          ]}
          body={teamMember}
          onRowClick={(rowData) => setTeamData(rowData) || openPopup()}
          actionField={
            <div className="flex items-center gap-2">
              <button onClick={() => openPopup()}>
                <PlusIcon isActive={isPopupOpen} />
              </button>
            </div>
          }
          apiLoadingState={{
            body: {
              isLoading: isLoading,
              isError: isError,
            },
          }}
          alternateDivs={{
            emptyData: (
              <div className="w-full h-full">
                <div className="flex justify-center items-center flex-col space-y-2 h-full ">
                  <NoTeamIcon />
                  <span className="text-14 text-black text-sm font-400">No Team Data is Available.</span>
                  {/* <span
                  onClick={() => openPopup()}
                  className="border px-5 py-1  bg-white cursor-pointer items-center text-center text-base font-medium  hover:border-[#1D4469] hover:text-[#1D4469] text-[#383838] rounded-md shadow-[0px_1px_0px_0px_rgba(0,0,0,0.10)_inset,0px_0px_4px_0px_rgba(0,0,0,0.15)]"
                >
                  + Add Team
                </span> */}
                </div>
              </div>
            ),
          }}
        />

        {isPopupOpen && (
          <div className="fixed inset-0 flex items-center justify-center z-[102]">
            <ReportingTeamModal
              isOpen={isPopupOpen}
              onClose={closePopup}
              teamData={teamData}
              refetchAllOption={refetchAllOption}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default CustomerReportingTeam;
